import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableCategoryCount',
  initialState: true,
  reducers: {
    setDisableCategoryCount(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableCategoryCount } = slice.actions;

export default slice.reducer;
